
"use client";

import React, { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { IMAGES } from "../constants/images";

const IntroAnimation = ({ children, onAnimationComplete }) => {
  const [checked, setChecked] = useState(false);
  const [showIntro, setShowIntro] = useState(false);
  const [startShutter, setStartShutter] = useState(false);
  const [videoLoaded, setVideoLoaded] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    const seen = sessionStorage.getItem("hasSeenGetgeekIntro");
    if (!seen) {
      setShowIntro(true);
      sessionStorage.setItem("hasSeenGetgeekIntro", "true");
    }
    setChecked(true);
  }, []);

  useEffect(() => {
    if (!checked || !showIntro) return;

    const timer = setTimeout(() => {
      setStartShutter(true);
      setTimeout(() => {
        setShowIntro(false);
        onAnimationComplete?.();
      }, 1200);
    }, 5000);

    return () => clearTimeout(timer);
  }, [checked, showIntro, onAnimationComplete]);

  const handleVideoEnd = () => {
    setStartShutter(true);
    setTimeout(() => {
      setShowIntro(false);
      onAnimationComplete?.();
    }, 1200);
  };

  const handleVideoLoaded = () => {
    setVideoLoaded(true);
    if (videoRef.current) {
      videoRef.current.play().catch(() => { });
    }
  };

  // 1) Abhi decide nahi hua (bohot chhota moment) -> children DOM mein rakho
  //    lekin visually hidden, taake koi flash na ho aur SEO ke liye bhi maujood rahe
  if (!checked) {
    return (
      <>
        <div
          style={{
            width: "100%",
            visibility: "hidden",
            position: "absolute",
            top: 0,
            left: 0,
          }}
        >
          {children}
        </div>
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "#FFFFFF",
            zIndex: 9999,
          }}
        />
      </>
    );
  }

  // 2) Intro pehlay dekh chuka -> seedha content dikhao
  if (!showIntro) {
    return <>{children}</>;
  }

  // 3) Intro dikhana hai -> children ko TURANT VISIBLE rakho (overlay ke neeche)
  //    taake jab overlay slide ho, content turant reveal ho, koi blank gap na aaye
  return (
    <>
      <div style={{ width: "100%" }}>{children}</div>

      <AnimatePresence>
        {showIntro && (
          <motion.div
            initial={{ opacity: 1, y: 0 }}
            animate={{
              y: startShutter ? "-100%" : 0,
              opacity: startShutter ? 0 : 1,
            }}
            exit={{ y: "-100%", opacity: 0 }}
            transition={{
              duration: 1.2,
              ease: [0.25, 0.1, 0.25, 1],
            }}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "#FFFFFF",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
              overflow: "hidden",
            }}
          >
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{
                opacity: videoLoaded ? 1 : 0,
                scale: videoLoaded ? 1 : 0.8,
              }}
              transition={{ duration: 0.8, ease: [0.25, 0.1, 0.25, 1] }}
              style={{
                position: "relative",
                width: "100%",
                height: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <video
                ref={videoRef}
                onLoadedData={handleVideoLoaded}
                onEnded={handleVideoEnd}
                muted
                playsInline
                style={{
                  maxWidth: "70%",
                  maxHeight: "70%",
                  width: "auto",
                  height: "auto",
                  objectFit: "contain",
                }}
              >
                <source src={IMAGES.WEBSITE_LOADER} type="video/mp4" />
              </video>
            </motion.div>

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.05 }}
              transition={{ duration: 2, delay: 0.5 }}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: `
                  radial-gradient(circle at 20% 80%, rgba(139, 92, 246, 0.1) 0%, transparent 50%),
                  radial-gradient(circle at 80% 20%, rgba(167, 139, 250, 0.1) 0%, transparent 50%),
                  radial-gradient(circle at 40% 40%, rgba(192, 132, 252, 0.1) 0%, transparent 50%)
                `,
                pointerEvents: "none",
              }}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default IntroAnimation;